import clsx from 'clsx';
import { CSSProperties, forwardRef, HTMLAttributes, MouseEvent } from 'react';

import { toRem } from '../../utils/ui';

import '../../../assets/fonts/icomoon/style.css';
import './icon.scss';

export const Icon = forwardRef((props: IconProps, ref: any) => {
  const { type, onClick, size = 18, multiColor, className, skeleton, tabIndex, ...rest } = props;

  return (
    <i
      className={clsx('icon', `icon-${type}`, skeleton, className, {
        'pointer-events-none': !!skeleton || !onClick,
        'multi-color': multiColor,
      })}
      ref={ref}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          onClick?.(e as unknown as MouseEvent<HTMLElement>);
        }
      }}
      role={!!onClick ? 'button' : ''}
      tabIndex={!!onClick ? tabIndex ?? 0 : tabIndex}
      style={
        {
          [`--size`]: toRem(size),
        } as CSSProperties
      }
      {...rest}
    >
      {multiColor && (
        <>
          <span className="path1" />
          <span className="path2" />
          <span className="path3" />
        </>
      )}
    </i>
  );
});

export interface IconProps extends HTMLAttributes<HTMLElement> {
  type: string;
  size?: number;
  tabIndex?: number;
  skeleton?: boolean;
  className?: string;
  multiColor?: boolean;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
}
